export const HarbourFunctions = {
  thumbnailPath,
};
function thumbnailPath(imageName) {
  return `/images/harbours/thumbnails/${imageName.substring(
    0,
    imageName.length - 5
  )}-tn.webp`;
}
